export default function (obj) {
	let sobj = obj.split('-');

	let id = sobj[2];

	let robj = sobj.slice(0, 2).join('-');

	let oo = sobj[3];

	let ooobj = obj;

	if (sobj[3]) {
		id = sobj[3];

		oo = sobj[2];

		ooobj = robj + '-' + oo;
	}

	let out = {};

	out.rootObj = robj;

	out.id = id;

	out.obj = obj;

	out.parentId = 0;

	out.parentObj = '';

	if (oo) {
		out.parentId = oo;

		out.parentObj = ooobj;
	}

	return out;
}
